import React from 'react';
import { Box, IconButton, LinearProgress, Paper, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { formatTime } from './watch-progress';

// Baris "Lanjutkan menonton" di halaman utama (seperti aplikasi streaming).
export default function ContinueWatching({ items, onOpen, onRemove }) {
    if (!items || items.length === 0) return null;
    return (
        <Box sx={{ px: { xs: 1.5, sm: 3 }, pb: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Lanjutkan menonton</Typography>
            <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 1 }}>
                {items.map((item) => {
                    const percent = item.duration ? Math.min(100, (item.position / item.duration) * 100) : 0;
                    return (
                        <Paper
                            key={item.key}
                            variant="outlined"
                            onClick={() => onOpen(item)}
                            sx={{ minWidth: 200, maxWidth: 220, p: 1.25, cursor: 'pointer', position: 'relative', flexShrink: 0, '&:hover': { borderColor: 'primary.main' } }}
                        >
                            <Tooltip title="Hapus dari daftar">
                                <IconButton
                                    size="small"
                                    onClick={(e) => { e.stopPropagation(); onRemove(item); }}
                                    sx={{ position: 'absolute', top: 2, right: 2 }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            </Tooltip>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, pr: 3 }}>
                                <PlayArrowIcon fontSize="small" color="primary" />
                                <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordBreak: 'break-word' }} title={item.name}>
                                    {item.name}
                                </Typography>
                            </Box>
                            <LinearProgress variant="determinate" value={percent} sx={{ mt: 1, height: 4, borderRadius: 2 }} />
                            <Typography variant="caption" color="text.secondary">
                                {formatTime(item.position)}{item.duration ? ` / ${formatTime(item.duration)}` : ''}
                            </Typography>
                        </Paper>
                    );
                })}
            </Box>
        </Box>
    );
}
